export const harisApiDomain = "https://user.binharis.com";
export const deliveryApiDomain = "https://hlzd-delivery-api.halalize.com";
// export const deliveryApiDomain = "https://delivery-api.ordering.in.th";
export const reportApiDomain = "https://report-api.halalize.com";
export const commerceApiDomain = "https://commerce-api.halalize.com";
/*
export const harisApiDomain = 'http://halalize-user:3001'
export const deliveryApiDomain = 'http://delivery-api:3002'
export const reportApiDomain = 'http://report-api:3034'
export const commerceApiDomain = 'http://commerce-api:3003'
*/

/*
export const userApiDomain = process.env.VUE_APP_USER_URL
export const productApiDomain = process.env.VUE_APP_PRODUCT_URL
export const orderApiDomain = process.env.VUE_APP_ORDER_URL
*/

export const googleMapApiDomain = "https://maps.googleapis.com/maps/api";
export const harisChannelKey =
  "GnnCfqcmfFyAy44V2v798NHkzUSqeSM7yywVDYvwz69SYhXHd444dTpKeRWHN7tA";
export const googleMapApiKey = "AIzaSyDGcTL9mawx4zD7wtn8JZFlum1DvvCHROk";
export const monthList = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
export const dayList = [
  "วันจันทร์",
  "วันอังคาร",
  "วันพุธ",
  "วันพฤหัสบดี",
  "วันศุกร์",
  "วันเสาร์",
  "วันอาทิตย์",
];
export const deliveryHourList = [
  "10:00",
  "11:00",
  "12:00",
  "13:00",
  "14:00",
  "15:00",
  "16:00",
  "17:00",
  "18:00",
  "19:00",
  "20:00",
  "21:00",
];
export default {
  harisApiDomain,
  deliveryApiDomain,
  reportApiDomain,
  harisChannelKey,
  googleMapApiKey,
  monthList,
  dayList,
  deliveryHourList,
};
